import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import styles from './LegalCompliance.module.scss';

const cx = classNames.bind(styles);

export interface LegalComplianceProps {
  isArticlePreview?: boolean;
  dataTestId?: string;
}

const LegalCompliance = ({ isArticlePreview, dataTestId }: LegalComplianceProps): ReactElement => {
  return (
    <div className={cx('body')}>
      <span className={cx('text')}>Legal Compliance</span>
      <a
        className={cx('link')}
        href="/disclaimer"
        target={isArticlePreview ? '_blank' : '_self'}
        data-testid={dataTestId}
        rel="noreferrer"
      >
        Please click here to review our Disclaimer
      </a>
    </div>
  );
};

export default LegalCompliance;
